var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SkillsImage',{class:`image ${_vm.visible && 'visible'}`})
}
var staticRenderFns = []

export { render, staticRenderFns }